import React, { Component } from 'react';
import cn from 'classnames';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Button, Form, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import { func } from 'prop-types';
import { FMessage } from '../../hoc/IntlComponents';

class ChangePasswordForm extends Component {
  static propTypes = {
    onSubmit: func.isRequired,
    endOtherSessions: func.isRequired,
    intl: intlShape.isRequired,
  };

  state = {
    errors: {},
    data: {
      current_password: '',
      new_password: '',
      re_new_password: '',
    },
  };

  resetFields = () => {
    this.setState({
      data: {
        current_password: '',
        new_password: '',
        re_new_password: '',
      },
    });
  };

  validate = (data) => {
    const errors = {};

    Object.keys(data).forEach((field) => {
      data[field].length === 0 && (errors[field] = 'empty');
    });

    if (Object.keys(errors).length > 0) {
      return errors;
    }

    if (data.new_password === data.current_password) {
      errors.new_password = 'different';
    }

    if (data.new_password.length < 6) {
      errors.new_password = 'min';
      return errors;
    }

    if (!/(?=.*\d)(?=.*[A-Z])/g.test(data.new_password)) {
      errors.new_password = 'symbols';
      return errors;
    }

    if (data.new_password !== data.re_new_password) {
      errors.re_new_password = 'confirm';
    }

    return errors;
  };

  onChange = (e) => {
    const { target } = e;

    this.setState((prevState) => ({
      data: {
        ...prevState.data,
        [target.name]: target.value,
      },
    }));
  };

  resetError = (e) => {
    const { target } = e;

    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        [target.name]: undefined,
      },
    }));
  };

  onSubmit = (e) => {
    e.preventDefault();

    const errors = this.validate(this.state.data);

    this.setState((prevState) => ({
      ...prevState,
      errors,
    }));

    if (Object.keys(errors).length === 0) {
      this.props.onSubmit(this.state.data).then(() => this.resetFields());
    }
  };

  endOtherSessions = (e) => {
    e.preventDefault();

    this.props.endOtherSessions().then(() => this.resetFields());
  };

  getInputs = () => {
    const {
      data: { current_password, new_password, re_new_password },
      errors,
    } = this.state;
    return [
      <>
        <Input
          type="password"
          name="current_password"
          id="password"
          value={current_password}
          onChange={this.onChange}
          onFocus={this.resetError}
          tabIndex="1"
          autoComplete="current-password"
          autoFocus
        />

        {errors.current_password && (
          <small className="form-text">
            <FMessage id={`password.error.${errors.current_password}`} />
          </small>
        )}
      </>,

      <>
        <Input
          type="password"
          name="new_password"
          id="newPassword"
          value={new_password}
          onChange={this.onChange}
          onFocus={this.resetError}
          autoComplete="new-password"
          tabIndex="2"
        />
        {errors.new_password && (
          <small className="form-text">
            <FMessage id={`password.error.${errors.new_password}`} />
          </small>
        )}
      </>,

      <>
        <Input
          type="password"
          name="re_new_password"
          id="confirmPassword"
          value={re_new_password}
          onChange={this.onChange}
          onFocus={this.resetError}
          autoComplete="new-password"
          tabIndex="3"
        />
        {errors.re_new_password && (
          <small className="form-text">
            <FMessage id={`password.error.${errors.re_new_password}`} />
          </small>
        )}
      </>,
    ];
  };

  renderInputs = (id) => {
    return this.getInputs()[id];
  };

  render() {
    const {
      errors,
      data: { current_password, new_password, re_new_password },
    } = this.state;
    const isChangePasswordDisabled = !current_password || !new_password || !re_new_password;

    return (
      <Form className="change-password-form" onSubmit={this.onSubmit}>
        <FormGroup
          className={cn('form-group-upper-label', { 'has-error': errors.current_password })}
        >
          <Label for="password">
            <FormattedMessage id="password.current" defaultMessage="Current password" />
          </Label>

          {this.renderInputs(0)}
        </FormGroup>

        <FormGroup className={cn('form-group-upper-label', { 'has-error': errors.new_password })}>
          <Label for="newPassword">
            <FormattedMessage id="password.new-password" defaultMessage="New password" />
          </Label>
          {this.renderInputs(1)}
        </FormGroup>

        <FormGroup
          className={cn('form-group-upper-label', { 'has-error': errors.re_new_password })}
        >
          <Label for="confirmPassword">
            <FormattedMessage
              id="password.confirm-new-password"
              defaultMessage="Confirm password"
            />
          </Label>

          {this.renderInputs(2)}
        </FormGroup>

        <Row>
          <Col className="change-password-form-actions">
            <Button onClick={this.endOtherSessions}>
              <FormattedMessage
                id="password.sessions.btn-label"
                defaultMessage="End other sessions"
              />
            </Button>
            <Button size="md" className="form-group-btn" disabled={isChangePasswordDisabled}>
              <FormattedMessage id="password.btn-label" defaultMessage="Change password" />
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default injectIntl(ChangePasswordForm);
